import { render } from "./SocialModal.vue?vue&type=template&id=0222dd77&scoped=true"
import script from "./SocialModal.vue?vue&type=script&lang=js"
export * from "./SocialModal.vue?vue&type=script&lang=js"

import "./SocialModal.vue?vue&type=style&index=0&id=0222dd77&lang=scss&scoped=true"

import exportComponent from "/Users/intr0vert/Git/ai-startup/aibanner/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0222dd77"]])

export default __exports__